export default __webpack_public_path__ + "static/media/get-a-pic-btn-1.356806ed.png";